import { Button, Dropdown, Input, InputRef, message, Space, Table, TableProps, Tag, Tooltip, Upload } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";
import SortIcon from "../../components/icons/SortIcon";
import { STATUS_CANCELLED, STATUS_REQUESTED, STATUS_UPLOADED, STATUS_UPLOADED_BY_CONSULTANT } from "../../constants/constants";
import FilterIcon from "../../components/icons/FilterIcon";
import FileIcon from "../../components/icons/FileIcon";
import FileIconSmall from "../../components/icons/FileIconSmall";
import EyeIcon from "../../components/icons/EyeIcon";
import DownloadIcon from "../../components/icons/DownloadIcon";
import InfoIcon from "../../components/icons/InfoIcon"; import SearchIconSmall from "../../components/icons/SearchIconSmall";
import { FilterDropdownProps } from "antd/es/table/interface";
import PdfViewerModal from "../components/Modal/PdfViewerModal";
import { deletePartnerFile, getPartnerAssetsRequests, getPartnerFile, uploadPartnerFile, UploadPartnerMandatoryFile } from "../../API/endpoints/Partner";
import AssetInfoModal from "../Organization/components/modals/AssetInfoModal";
import DeleteModalSimple from "../Organization/components/DeleteModalSimple";
import dayjs from "dayjs";
import UploadPartnerAssetModal from "./Profile/UploadPartnerAssetModal";
import ThreeDotsIcon from "../../components/icons/ThreeDotsIcon";

interface Props {
    partnerProfile: any;
    reload?: boolean;
}
const PartnerAssets = (props: Props) => {
    const { partnerProfile } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [isDeleteItem, setIsDeleteItem] = useState<any>({});
    const [isAddAsset, setIsAddAsset] = useState(false);
    const [isEditAsset, setIsEditAsset] = useState<any>({});
    const [isUploadAsset, setIsUploadAsset] = useState(false);
    const [isEditUploadAsset, setIsEditUploadAsset] = useState<any>({});

    const [pageNumber, setPageNumber] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);

    const [infoData, setInfoData] = useState<any>({})

    const [data, setData] = useState<any[]>([]);
    const [dataFiltered, setDataFiltered] = useState<any[]>([]);
    const [productsList, setProductsList] = useState<any[]>([]);

    const searchInput = useRef<InputRef>(null);
    const [searchKey, setSearchKey] = useState("");
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>([])

    const [pdfData, setPdfData] = useState<any>({});


    useEffect(() => {
        if (partnerProfile) {
            setLoading(true);
            setData([]);
            const where = selectedStatuses?.length > 0 ? ({
                status: selectedStatuses
            }) : undefined;

            getPartnerAssetsRequests(partnerProfile?.id, where)
                .then((response) => {
                    const docs = response?.data?.documents?.rows || [];
                    const reqs = response?.data?.requests?.rows || [];
                    const mandReqs = response?.data?.mandatoryDocs || [];

                    const combined = [...docs, ...reqs].sort(
                        (a, b) => dayjs(b.created_at).valueOf() - dayjs(a.created_at).valueOf()
                    );

                    setData([...mandReqs, ...combined]);
                    setTotalCount(response?.data?.documents?.count + response?.data?.requests?.count);
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error);
                });
        }

    }, [partnerProfile, reload])

    useEffect(() => {
        setDataFiltered((prev) => data?.filter((item: any) => item?.file_name?.toLowerCase().includes(searchKey?.toLowerCase())))
    }, [data, searchKey])


    const onSuccessUploadAsset = (data: any) => {
        setReload(!reload)
        messageApi.success("Asset uploaded successfully");
        setIsEditUploadAsset({});
        setIsUploadAsset(false);
    }

    const onCancelUploadAsset = () => {
        setIsEditUploadAsset({});
        setIsUploadAsset(false);
    }
    const onSuccessDeleteAsset = () => {
        messageApi.success("Asset deleted successfully");
        const newList = data.filter((item: any) => item?.id !== isDeleteItem?.id)
        setData([...newList])
        setIsDeleteItem({});
    }


    const statusFilters = [
        {
            text: 'Pending',
            value: STATUS_REQUESTED,
        },
        {
            text: 'Completed',
            value: "FILES",
        },
        {
            text: 'Cancelled',
            value: STATUS_CANCELLED,
        },
    ];

    const onFilter = (filters: any) => {
        setSelectedStatuses(filters?.status || [])
    }


    // ================================================================================================
    const handleSearch = (selectedKeys: any, confirm: any) => {
        confirm();
        if (selectedKeys[0] != undefined) {
            setSearchKey(selectedKeys[0]?.trim());
        }
    };

    const handleReset = (clearFilters: any) => {
        clearFilters();
        setSearchKey("");
    };

    const actionOptions = (record: any) => {
        let items: any = [];
        items.push(
            {
                key: '1',
                label: "Edit",
                onClick: () => {
                    if (record?.status === STATUS_REQUESTED) {
                        setIsEditAsset(record)
                        setIsAddAsset(true)
                    } else {
                        setIsEditUploadAsset(record)
                        setIsUploadAsset(true)
                    }

                }
            }
        )

        items.push({
            key: '2',
            danger: true,
            label: record?.status === STATUS_REQUESTED ? "Cancel request" : "Delete",
            onClick: () => setIsDeleteItem(record)
        })

        return items;
    }


    const handleUploadFile = (data: any, file: any) => {
        if (!file) return;


        const req = new FormData();
        req.append("partner_id", partnerProfile?.id);
        req.append("file", file);
        req.append("file_name", data?.file_name);
        req.append("file_type", "Partner Assets");
        req.append("service", "1");
        req.append("description", data?.description);

        if (data?.field_name && data?.field_name !== "non mandatory") {
            req.append("field", data?.field_name);
        }

        const uploadFn = data?.field_name && data?.field_name !== "non mandatory"
            ? UploadPartnerMandatoryFile
            : uploadPartnerFile;

        uploadFn(req)
            .then((res: any) => {
                setReload(!reload)
                messageApi.success("Document uploaded successfully");
            })
            .catch((err) => {
                console.error('err', err);
                messageApi.error("Failed to upload file. pls try again!")
            });
    };


    const downloadFile = (path: string) => {
        window.open(path, "_blank");
    };

    const getColumnSearchProps = (dataIndex: any) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }: FilterDropdownProps) => (
            <div style={{ padding: 8 }}>
                <Input
                    classNames={{
                        input: "text-[12px]"
                    }}
                    ref={searchInput}
                    placeholder={`Search`}
                    value={selectedKeys[0]}
                    prefix={<SearchIconSmall />}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm)}
                    className="mb-[8px]"
                />
                <div className="flex gap-2 justify-end">
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        className="text-[12px]"
                    >Reset</Button>
                    <Button
                        type="primary"
                        title="Search"
                        size="small"
                        className="text-[12px]"
                        onClick={() => handleSearch(selectedKeys as string[], confirm)}
                    >Search</Button>
                </div>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchIconSmall color={filtered ? "#0152FB" : "#667085"} />
        ),
    });


    const columns: TableProps['columns'] = [
        {
            title: "Document / File Name",
            dataIndex: 'file_name',
            key: 'file_name',
            width: "25%",
            sorter: true,
            sortIcon: ({ sortOrder }) => <SortIcon order={sortOrder} />,
            render: (text) => (
                <div className="flex gap-x-[10px] items-center">
                    <FileIcon />
                    <p className="m-0 text-[12px] font-[500]">{text}</p>
                </div>

            ),
            ...getColumnSearchProps("file_name")
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: "10%",
            render: (text) => (
                <Tooltip title={text}>
                    <p className="m-0 w-[220px] truncate">{text}</p>
                </Tooltip>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: "10%",
            align: 'center',
            filters: statusFilters,
            filterIcon: (filtered: boolean) => (
                <FilterIcon filtered={filtered} />
            ),
            render: (text, record: any) => (
                text && ![STATUS_UPLOADED, STATUS_UPLOADED_BY_CONSULTANT]?.includes(text) ? (
                    <Tag bordered={false} color={text === STATUS_REQUESTED ? "warning" : "error"} className="rounded-[16px] capitalize">{text?.replaceAll("_", " ")?.toLowerCase()}</Tag>
                ) : (
                    [STATUS_UPLOADED, STATUS_UPLOADED_BY_CONSULTANT]?.includes(text) ? (
                        <Tag bordered={false} color="success" className="rounded-[16px]">Completed</Tag>
                    ) : (
                        <></>
                    )

                )
            ),
        },
        {
            title: 'Files',
            dataIndex: 'path',
            key: 'path',
            width: "20%",
            render: (path, record: any) => (
                path ? (
                    <Space>
                        <FileIconSmall />
                        <Tooltip title={record?.file_name}>
                            <p className="m-0 w-[154px] truncate text-[12px] leading-[12px]">{record?.file_name}</p>
                        </Tooltip>
                        <Button type="text" size="small" icon={<EyeIcon />} className="bg-[#EDEDED]" onClick={() => setPdfData({ path: path, name: record?.file_name })} />
                        <Button type="text" size="small" icon={<DownloadIcon />} className="bg-[#EDEDED]" onClick={() => downloadFile(path)} />
                    </Space>
                ) : (
                    <></>
                )

            )
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            width: "20%",
            align: "end",
            render: (_, record: any) => (
                <Space>
                    {record?.path || record?.status === STATUS_CANCELLED ? (
                        <></>
                    ) : (
                        <Upload
                            className="w-full upload-form-item"
                            onChange={(e: any) => handleUploadFile(record, e?.file,)}
                            beforeUpload={(file) => {
                                return false
                            }}
                            showUploadList={false}
                        >
                            <Button type="primary" size="small" className="text-[12px] leading-[12px]" onClick={(e) => e.preventDefault()}>Upload</Button>
                        </Upload>
                    )}

                    {/* <Dropdown menu={{ items: actionOptions(record) }}>
                        <Button icon={<ThreeDotsIcon />} type="text" className="leading-[12px]" onClick={(e) => e.preventDefault()} />
                    </Dropdown> */}


                    <Button icon={<InfoIcon />} type="text" className="leading-[12px]" onClick={(e) => setInfoData(record)} />
                </Space>

            )
        },
    ]



    return (
        <div className="h-[calc(100vh-246px)] bg-white p-[20px] rounded-[8px]">
            {contextHolder}
            <div className="flex justify-end mb-[16px] stick">
                <Button type="primary" onClick={(e) => setIsUploadAsset(true)} >Upload Asset</Button>

            </div>
            <Table
                className="overflow-auto h-[calc(100%-32px)] w-full"
                size="small"
                rowKey={"id"}
                columns={columns}
                dataSource={dataFiltered}
                loading={loading}
                pagination={false}
                onChange={(_: any, filters: any) => onFilter(filters)}

            />
            <AssetInfoModal
                title={"Asset"}
                data={infoData}
                onClose={() => setInfoData({})}
            />
            <UploadPartnerAssetModal
                title={"Partner Assets"}
                open={isUploadAsset}
                editData={isEditUploadAsset}
                onCancel={() => onCancelUploadAsset()}
                onSuccess={(data: any) => onSuccessUploadAsset(data)}
                partnerProfile={partnerProfile}
            />
            <DeleteModalSimple
                title={"Alert"}
                content={"Are you sure you want to delete this asset ?"}
                okText={"Yes, Delete"}
                item={isDeleteItem}
                onCancel={() => setIsDeleteItem({})}
                onSuccess={() => onSuccessDeleteAsset()}
                api={deletePartnerFile}
            />
            <PdfViewerModal
                pdfData={pdfData}
                isPdfOpen={Object.keys(pdfData).length > 0}
                closeModal={() => setPdfData({})}
            />
        </div>
    )
}

export default PartnerAssets